import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHorn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 32,
	viewBox: "0 0 25 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.2402 24.3798C10.3431 24.5915 10.2596 24.8489 10.0538 24.9548C9.99597 24.9845 9.93217 25 9.86749 25H7.20833C6.97822 25 6.79167 24.8081 6.79167 24.5714L5.54167 18.6462H4.5C3.11929 18.6462 2 17.495 2 16.0748V13.5034C2 12.0832 3.11929 10.9319 4.5 10.9319H8.04167V18.6464L10.2402 24.3798ZM19.484 7.31784C19.4946 7.35698 19.5 7.39749 19.5 7.43819V21.9905C19.5 22.2324 19.3135 22.4286 19.0833 22.4286C19.0446 22.4286 19.0061 22.4229 18.9689 22.4117L9.29167 18.7857V10.6429L18.9689 7.01697C19.1901 6.9505 19.4207 7.08521 19.484 7.31784ZM21.5833 12.8605C21.8135 12.8605 22 13.0524 22 13.2891V16.2891C22 16.5258 21.8135 16.7176 21.5833 16.7176H20.75V12.8605H21.5833Z",
		fill: "#FC6917"
	})
});
export default SvgHorn;
